export default "__VITE_ASSET__92d899b1__"